import React, { useEffect, useState } from 'react';
import { getLookup } from '../../services/clinicPortalServices/lookupService';

// Feeds any list rendering (radio buttons, checkboxes, custom menus) from a Lookup List.
// <LookupOptions list="race" fallback={race}>{(opts) => opts.map(...)}</LookupOptions>
// Falls back to the built-in list until (or if) the lookup loads.
export default function LookupOptions({ list, fallback, children }) {
    const [items, setItems] = useState(null);
    useEffect(() => {
        let alive = true;
        getLookup(list).then((d) => { if (alive) setItems(d || []); });
        return () => { alive = false; };
    }, [list]);
    const opts = items && items.length ? items : fallback || [];
    return <>{children(opts)}</>;
}
